import { CladdingProduct, Product, ProductType, RoofTrimProduct } from '../';

export function IsRoofTrimProduct(product: Product): product is RoofTrimProduct {
  return (product as CladdingProduct).productType === ProductType.ROOF_TRIM;
}
